"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FindYourProduct = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _navigation = require("../../../context/navigation");
var _hooks = require("../../../hooks");
var _useTranslations = require("../../../hooks/useTranslations");
var _utils = require("../../../utils");
var _FindYourProductSkeleton = require("./FindYourProductSkeleton");
var _constant = require("./constant");
var _styles = require("./styles");
var _utils2 = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const FindYourProduct = () => {
  const {
    inspirationItems,
    loadingInspirationItems: loading
  } = (0, _navigation.useBurgerMenu)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const isMobile = (0, _hooks.useIsMobile)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const items = (0, _react.useMemo)(() => (0, _utils2.filterInspirationTiles)(inspirationItems), [inspirationItems]);
  // istanbul ignore next -- do not need to test on click event
  const analyticsData = (0, _react.useCallback)(url => () => {
    (0, _utils.logUserClick)(url);
  }, []);
  if (loading || items.length === 0) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FindYourProductSkeleton.FindYourProductSkeleton, {
      animation: loading ? 'pulse' : undefined
    });
  }
  if (isMobile) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
      "data-testid": getTestId(_constant.FIND_YOUR_PRODUCT_ROOT_MOBILE),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.FindYourProductList, {
        children: items.slice(0, _constant.MAX_NUMBER_OF_TILES).map(tile => /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.FindYourProductLink, {
            href: tile.url,
            onClick: analyticsData(tile.url),
            children: tile.title
          })
        }, tile.id))
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constant.FIND_YOUR_PRODUCT_ROOT_DESKTOP),
    children: items.slice(0, _constant.MAX_NUMBER_OF_TILES).map(tile => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CategoryBoxWrapper, {
      "aria-label": tile.title,
      type: "button",
      onClick: analyticsData(tile.url),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.CategoryBox, {
        title: tile.title,
        imageUrl: tile.imageUrl,
        buttonText: translations.view,
        relativeUrl: tile.url
      })
    }, tile.id))
  });
};
exports.FindYourProduct = FindYourProduct;
